import React, {Component} from 'react';
import PropTypes from 'prop-types';

import InputInlineEditable from '../../gd-components/input-inline-editable/input-inline-editable';
import ColorSelector from "../../gd-components/color/selector/selector";

import Classes from 'classnames';

export default class ItemRow extends Component {
    static propTypes = {
        item: PropTypes.object.isRequired,

        colorSelectionEnabled: PropTypes.bool,

        onItemRename: PropTypes.func,
        onItemChangeColor: PropTypes.func,
        onDeleteClick: PropTypes.func
    };

    static defaultProps = {
        colorSelectionEnabled: false
    }

    state = {
        isEditing: false
    };

    focus = () => {
        this.input.focus();
    }

    onInputFocus = () => {
        this.setState({
            isEditing: true
        }, ()=>{
            if (this.props.onEditState) this.props.onEditState(this.state.isEditing);
        });
    };

    onInputBlur = () => {
        const newValue = this.input.getValue();

        this.setState({
            isEditing: false
        },()=>{
            if (this.props.onEditState) this.props.onEditState(this.state.isEditing);
            if (this.inputChanged) {
                this.inputChanged = false;
                this.props.onItemRename(this.props.item.id, newValue);
            }
        })
    };

    onInputChange = (value) => {
        if (this.props.item.value !== value) {
            this.inputChanged = true;
            this.props.item.value = value;
        }
    }

    onChangeColor = (newValue) => {
        if (this.props.onItemChangeColor && this.props.item.color !== newValue) this.props.onItemChangeColor(this.props.item.id, newValue);
    }

    onDeleteClick = (e) => {
        if (!this.props.onDeleteClick) return;

        e.stopPropagation();
        this.props.onDeleteClick(this.props.item);
    };

    render() {
        const classes = Classes("ui5-cf-edit-option", {
            'with-color': this.props.colorSelectionEnabled,
            'hover': this.props.dndHover
        });

        return (
            <div className={classes}>
                <div className="handle"><div className="icon i5-dnd"/></div>
                <div className="input">
                    <InputInlineEditable ref={r=>this.input = r}
                                         className="value"
                                         placeholder=""
                                         value={this.props.item.value}
                                         onFocus={this.onInputFocus}
                                         onBlur={this.onInputBlur}
                                         onChange={this.onInputChange}/>

                    {this.props.colorSelectionEnabled &&
                    <ColorSelector className="color-selector" value={this.props.item.color} allowSelectEmpty={true} onChange={this.onChangeColor}/>}
                </div>

                {this.props.onDeleteClick &&
                <div className="action"><div className="button gd-btn-circle-delete-red-18" onClick={this.onDeleteClick}/></div>}
            </div>
        );
    }
}